module.exports = __webpack_public_path__ + "static/img/hbys-1.e3e5c0a0.png";